import React from 'react';
import { LogoMark } from '@/components/Logo';

// Shown briefly while a lazy-loaded route chunk downloads (Suspense
// fallback) — on a warm cache this is usually on screen for a single frame.
const PageLoader = () => (
  <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 flex items-center justify-center">
    <div className="animate-pulse">
      <LogoMark size="lg" />
    </div>
  </div>
);

export default PageLoader;
